import type { AxModelInfo } from '../types.js';

/**
 * HuggingFace: Model information
 */
export const axModelInfoHuggingFace: AxModelInfo[] = [];
